

















































































































































































import Vue from "vue";
import router from "@/router";
import AppFooter from "@/components/AppFooter.vue";

export default Vue.extend({
  name: "App",
  components: { AppFooter },
  data: () => ({
    routes: router.getRoutes(),
    burger_menu: false,
  }),
  computed: {
    theme() {
      return this.$vuetify.theme.currentTheme;
    },
  },
});
